import { AppBar, Container, Toolbar } from '@mui/material';
import { ComponentProps, ElementType } from 'react';

import styles from './app-header.module.scss';

import { AppHeaderAvatarBaseMenuProps, AppHeaderAvatarMenu } from './app-header-components/app-header-avatar-menu';
import { AppHeaderNav, NavLink } from './app-header-components/app-header-nav';

interface AppHeaderProps {
  avatarMenu?: AppHeaderAvatarBaseMenuProps;
  navLinks?: NavLink[];
  imageComponent?: ElementType<ComponentProps<'img'>>;
  logo?: ComponentProps<'img'>;
  testId?: string;
}

export const AppHeader = ({
  avatarMenu,
  imageComponent: ImageComponent = 'img',
  logo,
  navLinks,
  testId,
}: AppHeaderProps) => (
  <AppBar
    className={styles.AppHeader}
    data-testid={testId}
    elevation={2}
    position="sticky"
  >
    <Container maxWidth="xl">
      <Toolbar
        disableGutters
        className={styles.toolBar}
      >
        {logo ? (
          <ImageComponent
            className={styles.headerLogo!}
            data-testid={testId && `${testId}-headerLogo`}
            {...logo}
          />
        ) : null}

        {navLinks ? (
          <AppHeaderNav
            navLinks={navLinks}
            testId={testId && `${testId}-navLinks`}
          />
        ) : null}

        {avatarMenu ? (
          <AppHeaderAvatarMenu
            {...avatarMenu}
            testId={testId && `${testId}-avatarMenu`}
          />
        ) : null}
      </Toolbar>
    </Container>
  </AppBar>
);
